import "./CreateNewRestaurantPageCallback.css";

import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { RestaurantService } from "deliziora-client-module/client-web";

export default function CreateNewRestaurantPageCallbackLogin() {
  const navigate = useNavigate();
  const { isLoading, error, user, appState } = useAuth0();

  useEffect(() => {
    console.log("Auth0 Callback:", { isLoading, error, user, appState });
    if (user?.email) {
      RestaurantService.getRestaurantByEmail(user.email)
        .then((res) => {
          if (res.data) {
            localStorage.setItem("userData", JSON.stringify(res.data));
            window.location.href = `${window.location.origin}`;
          }
        }).catch((err) => {
          alert("Essa conta não está vinculada a nenhum restaurante");
          window.location.href = `${window.location.origin}`;
        });
    }
  }, [isLoading, appState, navigate]);

  if (isLoading) return <div>Aguarde...</div>;
  if (error) return <div>Erro: {error.message}</div>;

  return <div>Callback processando login... {JSON.stringify(user?.email)}</div>;
}
